import * as React from "react"

export default function FilterSolidIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M10 14L4 5V3h16v2l-6 9v6l-4 2v-8z" fill={props.fill} />
    </svg>
  )
}
